import { render, staticRenderFns } from "./ParallaxBody.vue?vue&type=template&id=3b360618"
import script from "./ParallaxBody.vue?vue&type=script&lang=js"
export * from "./ParallaxBody.vue?vue&type=script&lang=js"
import style0 from "./ParallaxBody.vue?vue&type=style&index=0&id=3b360618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports